import {
    asyncListWithSkipTakeCreate,
    cachedValueCreateWithParamsV2,
    Evaluable,
    evaluateWhenFunction,
    hashFunctionCreate,
    stringReplaceEmptyOrWhiteSpaceValue,
    valueConvertWhenNotNullable
} from '@wix/devzai-utils-common';
import type {DoppeDtoBlogPost} from '../../../client-server-common/types/doppe-dto-blog-post';
import type {IDoppeViewerApi} from '../../../client-server-common/api/doppe-viewer-api';

export function doppeViewerAsyncListFactoryBlogPosts(
    viewerApiClientGetter: Evaluable<() => IDoppeViewerApi>
) {
    return cachedValueCreateWithParamsV2({
        paramsHashFunction: hashFunctionCreate<doppeViewerAsyncListFactoryBlogPosts.Params>({
            search: hashFunctionCreate(),
        }),
        paramsNormalizationFunction: params => ({
            ...params,
            search: valueConvertWhenNotNullable(params.search, s =>
                stringReplaceEmptyOrWhiteSpaceValue(s, undefined)
            )
        }),
        valueFunction: (params) => {
            const viewerApiClient = evaluateWhenFunction(viewerApiClientGetter);

            return asyncListWithSkipTakeCreate<DoppeDtoBlogPost>({
                fetchFunction: async (skip, take) => {
                    return viewerApiClient.getBlogPosts({
                        skip: skip,
                        take: take,
                        search: params.search,
                    });
                },
                defaultTake: 30,
            });
        }
    });
}

export namespace doppeViewerAsyncListFactoryBlogPosts {
    export interface Params {
        search?: string;
    }
}

export function doppeViewerAsyncListFactoryBlogPostsByCategory(
    viewerApiClientGetter: Evaluable<() => IDoppeViewerApi>
) {
    return cachedValueCreateWithParamsV2({
        paramsHashFunction: hashFunctionCreate<doppeViewerAsyncListFactoryBlogPostsByCategory.Params>({
            categorySlug: hashFunctionCreate(),
        }),
        valueFunction: (params) => {
            const viewerApiClient = evaluateWhenFunction(viewerApiClientGetter);

            return asyncListWithSkipTakeCreate<DoppeDtoBlogPost>({
                fetchFunction: async (skip, take) => {
                    return viewerApiClient.getBlogPosts({
                        skip: skip,
                        take: take,
                        categorySlug: params.categorySlug,
                    });
                },
                defaultTake: 30,
            });
        }
    });
}

export namespace doppeViewerAsyncListFactoryBlogPostsByCategory {
    export interface Params {
        categorySlug: string;
    }
}
